import { Navigate } from "react-router-dom";
import Constant from "../util/constant";

/**
 * Club managers may view events and create new ones, but cannot open the edit form.
 */
const DenyClubManagerEventEdit = ({ children }) => {
  if (window.localStorage.getItem("role") === Constant.ROLES.CLUB_MANAGER) {
    return <Navigate to="/events-list" replace />;
  }
  return children;
};

export default DenyClubManagerEventEdit;
